import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { approveTransaction } from '../../../../crud/sendRecive.crud';

type UseApproveReturn = [
  (id: string) => Promise<void>,
  boolean,
  boolean
];

export const useApprove = (): UseApproveReturn => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const fetchApprove = useCallback(async (id: string) => {
    setLoading(true);
    setSuccess(false);

    try {
      await approveTransaction(id);

      enqueueSnackbar('Successfully approveded', {
        variant: 'success',
      });

      setSuccess(true);
    } catch (e) {
      enqueueSnackbar(
        `${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`,
        { variant: 'error' }
      );
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, intl]);

  return [fetchApprove, loading, success];
};
